export default {
  viewReview: {
    id: 'product_page_gallery_new_review_view_review',
    defaultMessage: 'View full review',
  },
} as const
